import { Injectable } from "@angular/core";
import { JobType } from "src/app/jobs/jobtypes";
import { Observable, throwError, of, Subject, BehaviorSubject } from "rxjs";
import { retry, catchError, map, finalize, tap } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { MessagerComponent } from "src/app/messager/messager/messager.component";

@Injectable({
  providedIn: "root",
})
export class JobTypeService {
  private baseURL = environment.baseUrl;
  private subject = new BehaviorSubject<JobType[]>([]);

  gridObject$: Observable<JobType[]> = this.subject.asObservable();
  isLoading = true;

  constructor(private http: HttpClient, private messager: MessagerComponent) {}

  init() {
    const http$ = this.gridHttp();

    http$
      .pipe(
        tap(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (res) => {
          this.subject.next(res.JobTypes);
        },
        (err) => {
        }
      );
  }

  getOneJobType(id: number): Observable<any> {
    return this.http
      .get(this.baseURL + "/rhAPI/jobEntry/getSingleJobType/" + id)
      .pipe(
        tap((event) => {
          const message = event.Message as unknown as string;
          if (event.Error) {
            this.messager.openSnackBar(message, "Close", "errorAlert");
          } else {
            this.messager.openSnackBar(message, "Editing...", "successAlert");
          }
        })
      );
  }

  saveEdit(id: number, changes): Observable<any> {
    const jobtypes = this.subject.getValue();

    const jtIndex = jobtypes.findIndex((jobtype) => jobtype.job_type_id === id);
    const newJTList = jobtypes.slice(0);


    newJTList[jtIndex] = {
      ...jobtypes[jtIndex],
      ...changes,
    };

    this.subject.next(newJTList);
    return this.http
      .post(this.baseURL + "/rhAPI/jobEntry/updateJobType/" + id, changes)
      .pipe(
        tap((event) => {
          const message = event.Message as unknown as string;
          if (event.Error) {
            this.messager.openSnackBar(message, "Close", "errorAlert");
            this.subject.next(jobtypes);
          } else {
            this.messager.openSnackBar(message, "", "successAlert");
          }
        })
      );
  }

  getInitial() {
    return this.gridObject$.pipe(map((objects) => objects));
  }

  gridHttp(): Observable<any> {
    return this.http.get<any[]>(
      this.baseURL + "/rhAPI/customerjobs/getJobTypesAll",
      { observe: "body" }
    );
  }

  add(changes): Observable<any> {
    const jobtypes = this.subject.getValue();
    const newJobTypes = jobtypes.slice(0);

    newJobTypes.unshift(changes);

    this.subject.next(newJobTypes);

    return this.http
      .post(this.baseURL + "/rhAPI/jobEntry/insertJobType/", changes)
      .pipe(
        tap((event) => {
          const message = event.Message as unknown as string;
          if (event.Error) {
            this.messager.openSnackBar(message, "Close", "errorAlert");
            this.subject.next(jobtypes);
          } else {
            this.messager.openSnackBar(message, "", "successAlert");
          }
        })
      );
  }

  copy(row): Observable<any> {
    return this.http.post(this.baseURL + "/rhAPI/jobtypes/copy/" + row.job_type_id, row).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, "Close", "errorAlert");
        } else {
          this.messager.openSnackBar('Successfully Copied.', "Close", "successAlert");
        }
      })
    );
  }

  addOneFrontend(changes): void {
    const list = this.subject.getValue();
    const newList = list.slice(0);

    newList.unshift(changes);
    this.subject.next(newList);
  }

  deleteOne(id: number) {
    const originalList = this.subject.getValue();
    const index = originalList.findIndex((object) => object.job_type_id === id);

    const newList = originalList.slice(0);

    newList.splice(index, 1);
    this.subject.next(newList);
  }

  deleteContact(id: number) {
    const originalList = this.subject.getValue();
    const index = originalList.findIndex((object) => object.job_type_id === id);

    const newList = originalList.slice(0);

    newList.splice(index, 1);
    this.subject.next(newList);
  }

  checkJobExist(value:string): Observable<any>{
    return this.http.get(this.baseURL + `/rhAPI/customerjobs/checkForDuplicatesJobTypes/${value}`)
  }

  jobIsSiteVisitReqd(jobTypeId: number): Observable<any> {
    return this.http.get(this.baseURL + `/rhAPI/customerjobs/jobTypeIsSiteVisitReqd/${jobTypeId}`)
  }

}
